var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.77513 16.9591L7.01769 16.9837L18.871 5.2672L14.6531 1L2.79975 12.7165L2.77513 16.9591ZM14.6367 3.82838L16.0426 5.25078L6.20089 14.9789L4.7867 14.9707L4.79491 13.5565L14.6367 3.82838Z",
    fill: "#767676"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 21L21.3333 21V19L0 19V21Z",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.38335881026a0677973c51ed25c383c2.svg";
export { ForwardRef as ReactComponent };